import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import BugReportIcon from '@material-ui/icons/BugReport';
import MoreVert from '@material-ui/icons/MoreVert';
import FileCopyTwoToneIcon from '@material-ui/icons/FileCopyTwoTone';
import React, { useState, useEffect } from 'react';
import { useEntityPermission } from '@backstage/plugin-catalog-react/alpha';
import { catalogEntityDeletePermission } from '@backstage/plugin-catalog-common/alpha';
import { UnregisterEntity } from './UnregisterEntity.esm.js';
import { useApi, alertApiRef } from '@backstage/core-plugin-api';
import useCopyToClipboard from 'react-use/esm/useCopyToClipboard';

const useStyles = makeStyles(
  (theme) => {
    return {
      button: {
        color: theme.page.fontColor
      }
    };
  },
  { name: "PluginCatalogEntityContextMenu" }
);
function EntityContextMenu(props) {
  const {
    UNSTABLE_extraContextMenuItems,
    UNSTABLE_contextMenuOptions,
    onUnregisterEntity,
    onInspectEntity
  } = props;
  const [anchorEl, setAnchorEl] = useState();
  const classes = useStyles();
  const unregisterPermission = useEntityPermission(
    catalogEntityDeletePermission
  );
  const isAllowed = unregisterPermission.allowed;
  const onOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const onClose = () => {
    setAnchorEl(void 0);
  };
  const alertApi = useApi(alertApiRef);
  const [copyState, copyToClipboard] = useCopyToClipboard();
  useEffect(() => {
    if (!copyState.error && copyState.value) {
      alertApi.post({
        message: "Copied!",
        severity: "info",
        display: "transient"
      });
    }
  }, [copyState, alertApi]);
  const extraItems = UNSTABLE_extraContextMenuItems && [
    ...UNSTABLE_extraContextMenuItems.map((item) => /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        key: item.title,
        onClick: () => {
          onClose();
          item.onClick();
        }
      },
      /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(item.Icon, { fontSize: "small" })),
      /* @__PURE__ */ React.createElement(ListItemText, { primary: item.title })
    )),
    /* @__PURE__ */ React.createElement(Divider, { key: "the divider is here!" })
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tooltip, { title: "More", arrow: true }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      "aria-label": "more",
      "aria-controls": "long-menu",
      "aria-haspopup": "true",
      "aria-expanded": !!anchorEl,
      role: "button",
      onClick: onOpen,
      "data-testid": "menu-button",
      className: classes.button,
      id: "long-menu"
    },
    /* @__PURE__ */ React.createElement(MoreVert, null)
  )), /* @__PURE__ */ React.createElement(
    Popover,
    {
      open: Boolean(anchorEl),
      onClose,
      anchorEl,
      anchorOrigin: { vertical: "bottom", horizontal: "right" },
      transformOrigin: { vertical: "top", horizontal: "right" },
      "aria-labelledby": "long-menu"
    },
    /* @__PURE__ */ React.createElement(MenuList, { autoFocusItem: Boolean(anchorEl) }, extraItems, /* @__PURE__ */ React.createElement(
      UnregisterEntity,
      {
        unregisterEntityOptions: UNSTABLE_contextMenuOptions,
        isUnregisterAllowed: isAllowed,
        onUnregisterEntity,
        onClose
      }
    ), /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        onClick: () => {
          onClose();
          onInspectEntity();
        }
      },
      /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(BugReportIcon, { fontSize: "small" })),
      /* @__PURE__ */ React.createElement(ListItemText, { primary: "Inspect entity" })
    ), /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        onClick: () => {
          onClose();
          copyToClipboard(window.location.toString());
        }
      },
      /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(FileCopyTwoToneIcon, { fontSize: "small" })),
      /* @__PURE__ */ React.createElement(ListItemText, { primary: "Copy entity URL" })
    ))
  ));
}

export { EntityContextMenu };
//# sourceMappingURL=EntityContextMenu.esm.js.map
